import { useCallback, useEffect, useMemo, useState } from 'react';
import { parameterService } from '../services/parameterService';

export const useTierParameters = (tierKey = 'current') => {
  const key = useMemo(() => tierKey || 'current', [tierKey]);
  const [state, setState] = useState({ loading: true, error: null, data: null });

  const fetchParameters = useCallback(() => {
    setState({ loading: true, error: null, data: null });
    parameterService
      .getUserParameters(key)
      .then((result) => {
        setState({ loading: false, error: null, data: result });
      })
      .catch((error) => {
        setState({ loading: false, error, data: null });
      });
  }, [key]);

  useEffect(() => {
    fetchParameters();
  }, [fetchParameters]);

  return {
    loading: state.loading,
    error: state.error,
    data: state.data,
    refresh: fetchParameters,
  };
};

export default useTierParameters;
